import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { ArrowRight, Mountain, Compass, Globe, Sparkles } from 'lucide-react';
import { adventureTemplates } from '../../data/adventureData';

const JourneySelector = ({ onSelectJourney }) => {
  const getRegionIcon = (region) => {
    if (region.includes('Everest')) return Mountain;
    if (region.includes('Multi')) return Globe;
    if (region.includes('Tibet')) return Sparkles;
    return Compass;
  };

  return (
    <div className="min-h-screen bg-white py-20 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-serif mb-6 text-zinc-900">
            Craft the Adventure of a Lifetime
          </h1>
          <p className="text-xl text-zinc-600 max-w-3xl mx-auto mb-4">
            This isn't a pre-packaged tour. It's your story.
          </p>
          <p className="text-lg text-zinc-500 max-w-2xl mx-auto">
            Start with a legendary journey and shape it to your wildest dreams. Your choices write the itinerary.
          </p>
          <div className="w-24 h-1 bg-amber-600 mx-auto mt-8" />
        </div>

        {/* Journey Cards */}
        <div className="mb-12">
          <h2 className="text-3xl font-serif text-center mb-12 text-zinc-900">
            Choose Your Starting Point
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {adventureTemplates.map((template) => {
              const Icon = getRegionIcon(template.region);
              return (
                <Card 
                  key={template.id}
                  className="group overflow-hidden hover:shadow-2xl transition-all duration-500 border-0 rounded-sm cursor-pointer"
                  onClick={() => onSelectJourney(template)}
                >
                  <div className="relative h-80 overflow-hidden">
                    <img 
                      src={template.heroImage} 
                      alt={template.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
                    <div className="absolute top-4 right-4">
                      <Icon className="w-8 h-8 text-amber-500" />
                    </div>
                    <div className="absolute bottom-6 left-6 right-6">
                      <h3 className="text-3xl font-serif text-white mb-2">{template.name}</h3>
                      <p className="text-white/90 text-sm mb-3">{template.description}</p>
                      <div className="flex items-center gap-4 text-sm text-white/80">
                        <span>📍 {template.region}</span>
                        <span>⏱️ {template.baseDuration} days</span>
                        <span>💰 From ${template.basePrice}</span>
                      </div>
                    </div>
                  </div>
                  <CardContent className="p-6 bg-zinc-50">
                    <Button 
                      className="w-full bg-emerald-800 hover:bg-emerald-900 text-white py-6 rounded-sm transition-all duration-300 group-hover:bg-amber-600"
                    >
                      Start Your {template.shortName} Story
                      <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                    </Button>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JourneySelector;